import { generateConfigPayload, isShowAppRegionField, ShowAppUrlBasedOnCatalogCode } from 'pages/reference-implementation/provisioning/RI003O/utils';
import { RICatalogCode003, RICatalogCode003A, RICatalogCode003O, RICatalogCode005 } from 'pages/reference-implementation/utils/RICatalogCode';
import { getLoggedUserClaims } from 'utils';
import { platformManaged, selectedEnv as selectedEnvConst } from './constant';
import { isSecondaryGrpOwner } from './checkValidFields';

export const getPreviewPayload = ({ order, secondaryApproverValue }) => {
    const components = order?.resourceMgmt?.[selectedEnvConst]?.components;
    return {
        'is-external': order?.isExternal === 'Yes',
        'application-service': order?.appProfile,
        'application-name': order?.applicationName,
        'app-short-name': order?.appShortName,
        'manager-id': order?.appOwnerDetails?.gpid,
        'business-owner-id': order?.businessContactDetails?.gpid,
        sector: order?.sector,
        ...(['cgf']?.includes(order?.sector?.toLowerCase()) && { division: order?.division }),
        ...(isShowAppRegionField({ order }) && { 'application-region': order?.region }),
        'budget-code': order?.budgetCode,
        ...(order?.enabledManualBudgetCode && { enabledManualBudgetCode: order?.enabledManualBudgetCode }),
        'data-classification': order?.dataClassification,
        // ...(order?.environment?.toLowerCase() === 'production' && {
        //     isaNumber: order?.isaNumber,
        //     'ite-application-name': order?.iteAppService,
        // }),
        ...(order?.isExternal === 'Yes' &&
            [RICatalogCode003, RICatalogCode003O, RICatalogCode003A, RICatalogCode005]?.includes(order?.catalogCode) && {
                'app-support-mail-id': order?.appSupportMailId,
            }),
        ...(order?.isExternal === 'Yes' &&
            [RICatalogCode005]?.includes(order?.catalogCode) && {
                // 'certificate-owner-one': order?.certificateOwnerOneDetails?.gpid,
                // 'certificate-owner-two': order?.certificateOwnerTwoDetails?.gpid,
                'active-directory-certificate-group': order?.adCertGroup,
            }),
        ...(order?.myCertADGroup === 'Yes' &&
            [RICatalogCode003, RICatalogCode003O, RICatalogCode003A]?.includes(order?.catalogCode) && {
                'active-directory-certificate-group': order?.adCertGroup,
            }),
        ...(order?.myCertADGroup === 'No' &&
            [RICatalogCode003, RICatalogCode003O, RICatalogCode003A]?.includes(order?.catalogCode) && {
                'active-directory-group-owner-id': order?.myCertADGroupOwnerDetails?.gpid,
            }),
        ...(isSecondaryGrpOwner({ order }) &&
            secondaryApproverValue?.value?.groupOwnerDetails?.gpid && {
                'active-directory-group-owner-id': secondaryApproverValue?.value?.groupOwnerDetails?.gpid,
            }),

        'environment-configurations': [
            {
                environment: order?.environment,
                ...(order?.isExternal === 'Yes' && ShowAppUrlBasedOnCatalogCode?.includes(order?.catalogCode) && { 'application-url': order?.appUrl }),
                ...(order?.privilegedADGroup === 'Yes' && { 'contributor-ad-groups': order?.privilegedADGroupList?.map((z) => z?.contributorValue) }),
                ...(order?.environment?.toLowerCase() !== 'production' &&
                    order?.nonPrivilegedADGroup === 'Yes' && { 'reader-ad-groups': order?.nonPrivilegedADGroupList?.map((z) => z?.readerValue) }),
                components: generateConfigPayload(components),
            },
        ],
    };
};

export const getCostCalcPayload = ({ order, selectedEnv }) => {
    const components = order?.resourceMgmt?.[selectedEnv]?.components;
    return {
        isExternal: order?.isExternal === 'Yes',
        catalogServiceCode: order?.catalogCode,
        components: generateConfigPayload(components),
        environment: order?.environment,
        sector: order?.sector,
        ...(['cgf']?.includes(order?.sector?.toLowerCase()) && { division: order?.division }),
        ...(isShowAppRegionField({ order }) && { applicationRegion: order?.region }),
        platformManaged,
    };
};

export const getOrderPayload = ({ order, secondaryApproverValue }) => {
    const components = order?.resourceMgmt?.[selectedEnvConst]?.components;

    return {
        ...(order?.orderId && {
            'order-id': order?.orderId,
        }),
        'is-external': order?.isExternal === 'Yes',
        'application-service': order?.appProfile,
        'application-name': order?.applicationName,
        'app-short-name': order?.appShortName,
        'manager-id': order?.appOwnerDetails?.gpid,
        'business-owner-id': order?.businessContactDetails?.gpid,
        sector: order?.sector,
        ...(['cgf']?.includes(order?.sector?.toLowerCase()) && { division: order?.division }),
        ...(isShowAppRegionField({ order }) && { 'application-region': order?.region }),
        'budget-code': order?.budgetCode,
        'data-classification': order?.dataClassification,
        // ...(order?.environment?.toLowerCase() === 'production' && {
        //     isaNumber: order?.isaNumber,
        //     'ite-application-name': order?.iteAppService,
        // }),
        ...(order?.isExternal === 'Yes' &&
            [RICatalogCode003, RICatalogCode003O, RICatalogCode003A, RICatalogCode005]?.includes(order?.catalogCode) && {
                'app-support-mail-id': order?.appSupportMailId,
            }),
        ...(order?.isExternal === 'Yes' &&
            [RICatalogCode005]?.includes(order?.catalogCode) && {
                // 'certificate-owner-one': order?.certificateOwnerOneDetails?.gpid,
                // 'certificate-owner-two': order?.certificateOwnerTwoDetails?.gpid,
                'active-directory-certificate-group': order?.adCertGroup,
            }),
        ...(order?.myCertADGroup === 'Yes' &&
            [RICatalogCode003A, RICatalogCode003, RICatalogCode003O]?.includes(order?.catalogCode) && {
                'active-directory-certificate-group': order?.adCertGroup,
            }),
        ...(order?.myCertADGroup === 'No' &&
            [RICatalogCode003, RICatalogCode003O, RICatalogCode003A]?.includes(order?.catalogCode) && {
                'active-directory-group-owner-id': order?.myCertADGroupOwnerDetails?.gpid,
            }),
        ...(isSecondaryGrpOwner({ order }) &&
            secondaryApproverValue?.value?.groupOwnerDetails?.gpid && {
                'active-directory-group-owner-id': secondaryApproverValue?.value?.groupOwnerDetails?.gpid,
            }),

        'environment-configurations': [
            {
                environment: order?.environment,
                ...(order?.isExternal === 'Yes' && ShowAppUrlBasedOnCatalogCode?.includes(order?.catalogCode) && { 'application-url': order?.appUrl }),
                ...(order?.privilegedADGroup === 'Yes' && { 'contributor-ad-groups': order?.privilegedADGroupList?.map((z) => z?.contributorValue) }),
                ...(order?.environment?.toLowerCase() !== 'production' &&
                    order?.nonPrivilegedADGroup === 'Yes' && { 'reader-ad-groups': order?.nonPrivilegedADGroupList?.map((z) => z?.readerValue) }),
                components: generateConfigPayload(components),
            },
        ],
    };
};

export const getResubmitOrderPayload = ({ order }) => {
    const catalog = order?.catalogServices?.[0]?.catalogConfig;

    const environmentDetails = catalog?.environmentConfigurations[0];
    const components = environmentDetails?.components;

    return {
        ...(catalog?.projectId && { 'project-id': catalog?.projectId }),
        ...(catalog?.businessUnit && { 'business-unit': catalog?.businessUnit }),
        sector: catalog?.sector,
        ...(['cgf']?.includes(catalog?.sector?.toLowerCase()) && { division: catalog?.division }),
        ...(isShowAppRegionField({ order: { sector: catalog?.sector, catalogCode: order?.catalogCode } }) && { 'application-region': catalog?.region }),
        'budget-code': catalog?.costCenter,
        ...(catalog?.billingInformation && { 'billing-information': catalog?.billingInformation }),

        'data-classification': catalog?.dataClassification,
        // ...(order?.environment?.toLowerCase() === 'production' && {
        //     isaNumber: order?.isaNumber,
        //     'ite-application-name': order?.iteAppService,
        // }),
        'manager-id': order?.manager?.id,
        'application-service': catalog?.applicationService,
        'application-name': catalog?.applicationName,
        'app-short-name': catalog?.applicationShortName,
        'business-owner-id': catalog?.businessOwnerId,
        ...(catalog?.readerAdGroup && catalog?.readerAdGroup?.length && { 'reader-ad-group': catalog?.readerAdGroup }),
        ...(catalog?.contributorAdGroup && catalog?.contributorAdGroup?.length && { 'contributor-ad-group': catalog?.contributorAdGroup }),

        ...([RICatalogCode003, RICatalogCode003O, RICatalogCode003A, RICatalogCode005]?.includes(order?.catalogCode) && {
            'app-support-mail-id': catalog?.appSupportMailId,
        }),
        ...([RICatalogCode003A, RICatalogCode003, RICatalogCode003O, RICatalogCode005]?.includes(order?.catalogServices?.[0]?.catalogServiceCode) && {
            // 'certificate-owner-one': catalog?.certificateOwnerOne,
            // 'certificate-owner-two': catalog?.certificateOwnerTwo,
            'active-directory-certificate-group': order?.adCertGroup,
        }),
        ...([RICatalogCode003, RICatalogCode003O, RICatalogCode003A]?.includes(order?.catalogCode) && {
            'active-directory-group-owner-id': order?.myCertADGroupOwnerDetails?.gpid,
        }),
        ...(order?.activeDirectoryGroupOwner && { 'active-directory-group-owner-id': order?.activeDirectoryGroupOwner?.id }),
        'environment-configurations': [
            {
                environment: environmentDetails?.environmentDisplayName,
                ...(environmentDetails?.applicationUrl && { 'application-url': environmentDetails?.applicationUrl }),
                ...(environmentDetails?.contributorAdGroups &&
                    environmentDetails?.contributorAdGroups?.length && {
                        'contributor-ad-groups': environmentDetails?.contributorAdGroups?.map((z) => z),
                    }),
                ...(environmentDetails?.environmentDisplayName?.toLowerCase() !== 'production' &&
                    environmentDetails?.readerAdGroups &&
                    environmentDetails?.readerAdGroups?.length && { 'reader-ad-groups': environmentDetails?.readerAdGroups?.map((z) => z) }),
                components: components.map((component) => ({
                    ...component,
                    program: component.program === 'Global Shared' ? 'Not Applicable' : component.program,
                })),
            },
        ],
    };
};

const getKafkaTopics = (topics) => {
    const getConsumerGrps = (grps) => {
        const res = grps?.map((grp) => grp?.value).toString();
        return res;
    };
    return topics?.map((topic) => ({
        topicName: topic?.topicName,
        consumerGroup: getConsumerGrps(topic?.consumerGroups),
        isTransactional: topic?.isTransactionalId === 'Yes',
        transactionPrefixText: topic?.transactionprefixtext || null,
        partitionCount: topic?.partitions || null,
        retentionUnit: topic?.retention?.retentionUnit || null,
        retentionPeriod: topic?.retention?.retentionDetails?.millisec || null,
        producerId: topic?.writeAccessUser || null,
        consumerId: topic?.readAccessUser || null,
        transactionPrincipalId: topic?.transactionalPrincipalId || null,
        // isProducerRequired: topic?.isWriteAccess === 'Yes',
        // isConsumerRequired: topic?.isReadAccess === 'Yes',
    }));
};
export const getKafkaValidPayload = (formData, order) => {
    const userClaims = getLoggedUserClaims();

    return {
        project: order?.appShortName || null, //     ask drona
        environment: order?.environment,
        ldapGroup: formData?.ldap,
        program: formData?.program === 'Not Applicable' ? 'Global Shared' : formData?.program,
        sector: order?.sector || null,
        catalogType: 'Kafka',
        budgetCode: order?.budgetCode || null,
        applicationService: order?.appProfile,
        division: order?.division || null,
        applicationRegion: order?.region || null,
        catalogServiceCode: 'RI003', //   order?.catalogCode
        businessUnit: formData?.businessUnit,
        appOwner: order?.appOwnerDetails?.gpid,
        createdBy: userClaims?.accessToken?.claims?.gpid,
        topics: getKafkaTopics(formData?.kafkatopics),
    };
};

export const getdevXOrderPayload = ({ order, params, riOrderId }) => {
    const components = order?.resourceMgmt?.[selectedEnvConst]?.components;

    return {
        journeyId: params?.journeyId,
        applicationId: params?.appRegistrationId,
        workflowName: 'InfraOnboarding',
        atomicWorkflowRequestList: [
            {
                atomicWorkflowName: 'InfraOnboarding_RI003O',
                inputData: {
                    orderId: riOrderId,
                    sector: order?.sector,
                    applicationService: order?.appProfile,
                    applicationName: order?.applicationName,
                    applicationShortName: order?.appShortName,
                    ...(['cgf']?.includes(order?.sector?.toLowerCase()) && { division: order?.division }),
                    ...(isShowAppRegionField({ order }) && { applicationRegion: order?.region }),
                    applicationOwner: order?.appOwnerDetails,
                    businessOwner: order?.businessContactDetails,
                    budgetCode: order?.budgetCode,
                    dataClassification: order?.dataClassification,
                    riDevelopmentType: order?.isExternal === 'Yes' ? 'Web Application' : 'Microservice',
                    ...(order?.isExternal === 'Yes' && {
                        teamDL: order?.appSupportMailId,
                        // certificateOwner1: order?.certificateOwnerOneDetails,
                        // certificateOwner2: order?.certificateOwnerTwoDetails,
                        activeDirectoryCertificateGroup: order?.adCertGroup,
                    }),
                    ...(order?.myCertADGroup === 'Yes' && {
                        activeDirectoryCertificateGroup: order?.adCertGroup,
                    }),
                    ...(order?.myCertADGroup === 'No' && {
                        activeDirectoryGroupOwner: order?.myCertADGroupOwnerDetails?.gpid,
                    }),
                    'environment-configurations': [
                        {
                            environment: order?.environment,
                            ...(order?.isExternal === 'Yes' && { 'application-url': order?.appUrl }),
                            'contributor-ad-groups': order?.privilegedADGroupList?.map((z) => z?.contributorValue),
                            'reader-ad-groups': order?.nonPrivilegedADGroupList?.map((z) => z?.readerValue),
                            components: generateConfigPayload(components),
                        },
                    ],
                },
            },
        ],
    };
};
